import type { RoutingRule } from '../models/types';
import type { RuleStatusTab } from '../constants/constants';

export function filterRoutingRules(
  rules: RoutingRule[],
  options: { search: string; status: RuleStatusTab },
): RoutingRule[] {
  const query = options.search.trim().toLowerCase();

  return rules.filter((rule) => {
    if (options.status === 'Active' && !rule.active) return false;
    if (options.status === 'Inactive' && rule.active) return false;
    if (!query) return true;

    const haystack = [
      rule.name,
      rule.merchantName,
      rule.fallbackMidLabel,
      ...(rule.groups ?? []).flatMap((group) => [
        group.targetMidLabel,
        group.countryOperator === 'NOT_IN' ? 'not in' : null,
        group.countryCodes,
        group.currencyOperator === 'NOT_IN' ? 'not in' : null,
        group.currencies,
        group.userEmailOperator === 'NOT_IN' ? 'not in' : null,
        group.userEmails,
        group.deviceTypes,
        group.riskRules,
      ]),
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return haystack.includes(query);
  });
}
